import { enumOf, useTableParams, type FieldSpec } from "@/hooks/useTableParams";

/** `all` is this toolbar's no-filter sentinel (Radix Select forbids `""`). */
const DEFAULTS = { status: "all" };

/** URL-backed toolbar state for the company disputes list. */
export const useDisputeParams = () =>
  useTableParams<typeof DEFAULTS>({
    defaults: DEFAULTS,
    schema: {
      status: enumOf(["all", "PENDING", "RESOLVED", "REJECTED"]),
    } satisfies Partial<Record<keyof typeof DEFAULTS, FieldSpec>>,
  });
